import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClipboardModule } from 'ngx-clipboard';

import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SiteLayoutComponent } from './components/site-layout/site-layout.component';
import { LoginComponent } from './components/login/login.component';
import { AuthLayoutComponent } from './components/auth-layout/auth-layout.component';

import { Global } from "./classes/global";
import { TokenInterceptor } from "./classes/interceptor";
import { OrdersComponent } from './components/orders/orders.component';
import { ConfirmActionComponent } from './components/confirm-action/confirm-action.component';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PaginationComponent } from './components/pagination/pagination.component';
import { EditableComponent } from './components/editable/editable.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccountAdminComponent } from './components/account-admin/account-admin.component';
import { AccountDetailComponent } from './components/account-detail/account-detail.component';
import { ChartsModule } from 'ng2-charts';
import { AccountMessageComponent } from './components/account-message/account-message.component';
import { RedBubbleOrderComponent } from './components/red-bubble-order/red-bubble-order.component';
import { AsinReportComponent } from './components/asin-report/asin-report.component';
import { CheckTrademarkComponent } from './components/check-trademark/check-trademark.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MerchantListComponent } from './components/merchant-list/merchant-list.component';
import { AutoCommandsComponent } from './components/auto-commands/auto-commands.component';
import { CreateBuyLabelCommandComponent } from './components/create-buy-label-command/create-buy-label-command.component';
import { DashboardV2Component } from "./components/dashboard-v2/dashboard-v2.component";
import { MerchantNetworthComponent } from './components/dashboard-v2/merchant-networth/merchant-networth.component';
import { ReportLoadingComponent } from './components/dashboard-v2/report-loading/report-loading.component';
import { BuyTiktokLabelComponent } from './components/buy-tiktok-label/buy-tiktok-label.component';
import { InventoryComponent } from './components/inventory/inventory.component';
import { InventoryOutputComponent } from './components/orders/inventory-output.component';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SiteLayoutComponent,
    LoginComponent,
    AuthLayoutComponent,
    OrdersComponent,
    PaginationComponent,
    RedBubbleOrderComponent,
    EditableComponent,
    AccountAdminComponent,
    AccountDetailComponent,
    AccountMessageComponent,
    RedBubbleOrderComponent,
    AsinReportComponent,
    CheckTrademarkComponent,
    MerchantListComponent,
    MerchantListComponent,
    AutoCommandsComponent,
    CreateBuyLabelCommandComponent,
    ConfirmActionComponent,
    DashboardV2Component,
    MerchantNetworthComponent,
    ReportLoadingComponent,
    BuyTiktokLabelComponent,
    InventoryComponent,
    InventoryOutputComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    ClipboardModule,
    ToastrModule.forRoot(),
    NgbModule,
    ChartsModule,
    NgSelectModule
  ],
  providers: [
    Global,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
